const EULATopics = [
    {
      topic: "EULA",
      id: "EULA1",
    },

  ];
  
  export default EULATopics;
  